import * as React from "react";
const SvgEdit04 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.769 2.768a3.156 3.156 0 1 1 4.462 4.464L7.67 19.795c-.311.31-.58.59-.911.793a3 3 0 0 1-.878.363c-.377.09-.765.084-1.205.084H3A1.035 1.035 0 0 1 1.965 20v-1.674c0-.44-.007-.83.084-1.206.074-.31.197-.606.363-.877.203-.33.482-.601.793-.912zm4.467 14.534a1.035 1.035 0 0 1 1.528 1.396l-1 1.095c-.716.783-1.708 1.242-2.764 1.242a3.75 3.75 0 0 1-2.763-1.241A1.68 1.68 0 0 0 14 19.225a1.68 1.68 0 0 0-1.237.569 1.036 1.036 0 0 1-1.526-1.4c.717-.78 1.708-1.239 2.763-1.239s2.046.458 2.763 1.24h.002c.345.378.791.57 1.235.57s.891-.192 1.236-.57zm-16.2 1.663h.639c.537 0 .638-.007.721-.027a1 1 0 0 0 .28-.115c.073-.045.148-.111.53-.492L18.768 5.768a1.087 1.087 0 0 0-1.538-1.536L4.67 16.795c-.38.38-.447.456-.492.529a1 1 0 0 0-.115.28c-.02.083-.027.184-.027.722z"
}));
export default SvgEdit04;
//# sourceMappingURL=Edit04.js.map